import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Badge } from 'react-bootstrap';
import { useAtom } from 'jotai';
import { authAtom } from "./Atoms";
import { FaCar, FaSatellite } from "react-icons/fa";
import { AnimatedNavButton } from "./components/AnimatedNavButton";
import { BarChartFill, FolderFill, GripVertical } from "react-bootstrap-icons";
import { ReactNode } from "react";
import { BreakpointDebugger } from "./components/BreakpointDebugger";

type AppButtonProps = {
    to:        string;
    icon:      ReactNode;
    text:      string;
    eventKey:  number;
    className?: string;
};

const AppButton = ( { to, icon, text, eventKey, className }: AppButtonProps ) => (
    <AnimatedNavButton
        to={to}
        eventKey={eventKey}
        className={`fs-6 text-body text-nowrap ${className ?? ""}`}>
        <div className="d-inline-flex align-items-center gap-2">
            <div>{icon}</div>
            <div>{text}</div>
        </div>
    </AnimatedNavButton>
);

export function App() {
    const [user, setUser] = useAtom( authAtom );
    const isLoggedIn      = user.isAuthenticated;
    const location        = useLocation();
    const isAuthPage = ['/login', '/forgot', '/reset'].some(
        path => location.pathname.startsWith( path )
    );

    function logout() {
        setUser( { isAuthenticated: false } );
    }
    
    return (
        <div id="main">
            <Navbar collapseOnSelect
                    className="px-3 border-bottom-2 border-bottom"
                    expand="lg"
                    bg="body"
                    variant="light">
                <Navbar.Brand href="/" className="fs-5 d-flex align-items-center gap-2">
                    <img src="/logo-1.svg" style={{ height: "2em", padding: "5px" }} />
                    <div className="d-flex gap-2 flex-row align-items-center">
                        <div>
                            <span className="">Zone</span>
                            <span className="fw-bold" style={{ textDecoration: "underline", textDecorationColor: "var(--bs-highlight)"}}>
                                Sentinel
                            </span>
                            <span> </span>
                        </div>
                        <GripVertical className="d-none d-md-block" />
                        {/* <TbMapPin /> */}                        
                        <div className="d-none d-md-block fs-5 py-1 border-2 text-highlight text-decoration-underline">
                            {user.employee?.municipality.name}
                        </div>
                        {user.employee?.employeeId === 1 && <BreakpointDebugger />}
                    </div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
                    <Nav>
                         {isLoggedIn && (
                            <>
                                <AppButton eventKey={1} to="/image"         icon={<FaSatellite  />} text="Images"   />
                                <AppButton eventKey={2} to="/abandoned/run" icon={<FaCar        />} text="Detect"  />
                            {/* <AppButton eventKey={3} to="/report"        icon={<BarChartFill />} text="Reports"  /> */}
                                <AppButton eventKey={4} to="/dataset"       icon={<FolderFill   />} text="Datasets" />
                            </>
                        )}
                        {isLoggedIn ? (
                            <NavDropdown align="end" title={user?.employee?.name || 'Account'} id="user-dropdown">
                                <NavDropdown.Item as={NavLink} to="/profile">Profile</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
                            </NavDropdown>
                        ) : (
                            <Nav.Link eventKey={5} as={NavLink} to="/login" className="fs-6">
                                Login
                            </Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <div id="content">
                <Outlet />
            </div>
        </div>
    );
}